"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-scroll-area";
//#region src/components/atoms/ScrollArea/ScrollArea.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "scroll-area",
	...e,
	ref: r
}));
r.displayName = "ScrollAreaRoot";
var i = e((e, r) => /* @__PURE__ */ t(n.Viewport, {
	"data-slot": "scroll-area-viewport",
	...e,
	ref: r
}));
i.displayName = "ScrollAreaViewport";
var a = e((e, r) => /* @__PURE__ */ t(n.Thumb, {
	"data-slot": "scroll-area-thumb",
	...e,
	ref: r
}));
a.displayName = "ScrollAreaThumb";
var o = e(({ children: e, ...r }, i) => /* @__PURE__ */ t(n.Scrollbar, {
	"data-slot": "scroll-area-scrollbar",
	...r,
	ref: i,
	children: e ?? /* @__PURE__ */ t(a, {})
}));
o.displayName = "ScrollAreaScrollbar";
var s = e((e, r) => /* @__PURE__ */ t(n.Corner, {
	"data-slot": "scroll-area-corner",
	...e,
	ref: r
}));
s.displayName = "ScrollAreaCorner";
//#endregion
export { s as ScrollAreaCorner, r as ScrollAreaRoot, o as ScrollAreaScrollbar, a as ScrollAreaThumb, i as ScrollAreaViewport };
